export enum AlertID {
  APP_UPDATE_AVAILABLE = "app-update-alert",
  CHANGELOG_AVAILABLE = "changelog-available-alert",
}
